<template>
  <q-dialog v-model="visible" @before-hide="beforeHide">
    <q-card style="max-height: 60vh; width: 600px; max-width: 80vw">
      <q-card-section>
        <div class="text-h6">客户信息</div>
      </q-card-section>

      <q-separator />

      <q-card-section class="scroll" >
        <div class="q-gutter-y-md column">
          <q-input v-model="customer.customerName" label="客户名称">
            <template v-slot:prepend>
              <q-icon name="business" />
            </template>
          </q-input>

          <q-input v-model="customer.customerShortName" label="客户简称">
            <template v-slot:prepend>
              <q-icon name="person" />
            </template>
          </q-input>

          <q-input v-model="customer.taxNo" label="税号" clearable> </q-input>

          <q-input v-model="customer.address" label="地址" clearable>
            <template v-slot:prepend>
              <q-icon name="place" />
            </template>
          </q-input>

          <q-input v-model="customer.telephone" label="电话" clearable>
          </q-input>

          <q-input v-model="customer.openBank" label="开户行" clearable>
          </q-input>

          <q-input v-model="customer.account" label="帐号" clearable> </q-input>

          <q-input v-model="customer.bankNo" label="行号" clearable> </q-input>

          <q-input v-model="customer.contact" label="联系人">
            <template v-slot:prepend>
              <q-icon name="contact_phone" />
            </template>
          </q-input>
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="right">
        <q-btn flat label="取消" color="primary" @click="beforeHide" />
        <q-btn flat label="保存" color="primary" @click="onSubmit" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { saveOrUpdateCust } from "@/api/erp/customer.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    customer: Object,
  },
  methods: {
    onSubmit() {
      var self = this;
      saveOrUpdateCust(self.customer).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.$q.notify({ type: "positive", message: "保存成功" });
          self.beforeHide();
          self.$emit("query");
        } else {
          self.$q.notify({ type: "negative", message: response.data.errorMsg });
        }
      });
    },
    beforeHide() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style>
</style>